// extracted by mini-css-extract-plugin
export default {"colorPicker":"colorPicker_colorPicker__L8XOM","removeColor":"colorPicker_removeColor__9lWPD","moreColors":"colorPicker_moreColors__eX8mR"};